import { SessionStorageKey } from '@/lib/storageConstants'
import { unprotectedRoutes } from './unprotectedRoutes'

const isSafeInternalPath = (path: unknown): path is string => {
    return (
        typeof path === 'string' &&
        path.startsWith('/') &&
        !path.startsWith('//') &&
        !path.startsWith('/\\')
    )
}

export const storeReturnPath = (asPath: string): void => {
    if (typeof window === 'undefined' || !isSafeInternalPath(asPath)) {
        return
    }

    const pathname = asPath.split('?')[0]
    if (
        pathname === '/' ||
        pathname === '/onboarding' ||
        unprotectedRoutes.includes(pathname)
    ) {
        return
    }

    window.sessionStorage.setItem(SessionStorageKey.RETURN_TO, asPath)
}

export const redirectToLogin = (): void => {
    if (typeof window === 'undefined') {
        return
    }

    storeReturnPath(
        window.location.pathname +
            window.location.search +
            window.location.hash,
    )
    window.location.pathname = '/login'
}

export const consumeReturnPath = (): string | null => {
    if (typeof window === 'undefined') {
        return null
    }

    const stored = window.sessionStorage.getItem(SessionStorageKey.RETURN_TO)
    window.sessionStorage.removeItem(SessionStorageKey.RETURN_TO)

    return isSafeInternalPath(stored) ? stored : null
}
